import { render, staticRenderFns } from "./LocationEdit.vue?vue&type=template&id=23fd69b6&scoped=true"
import script from "./LocationEdit.vue?vue&type=script&lang=js"
export * from "./LocationEdit.vue?vue&type=script&lang=js"
import style0 from "./LocationEdit.vue?vue&type=style&index=0&id=23fd69b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd69b6",
  null
  
)

export default component.exports